import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { CompanyDto } from "src/dtos/company/companyDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { titleMRClass } from "src/components/common/common";
import { handleKeyDownSelect } from "src/utils/commonForm/commonFormUtils";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";

interface DropDownFormProps<T> {
	title: string;
	data: T[];
	titleless?: boolean;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
	name?: string;
	initLabelLess?: boolean;
	initLabel?: string;
	editable?: boolean;
	value?: string;
	onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
	onKeyDown?: (e: KeyboardEvent<HTMLParagraphElement>) => void;
}

export const DropDownForm = <T,>(props: DropDownFormProps<T>) => {

	const { 
		title,
		data,
		titleless = false,
		wrapperOption = {
			wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
			titleStyle: "w-[100px] min-w-[100px] text-left",
			inputStyle: "w-[200px] min-w-[200px]",
		},
		name,
		initLabelLess = false,
		initLabel = '전체',
		onChange,
		value,
		editable = true,
		onKeyDown,
	} = props;

	const inputRef = useRef<HTMLSelectElement>(null);

	const pTagProcess = () => {
		inputRef.current?.focus();
		const mousedownEvent = new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window });
		inputRef.current?.dispatchEvent(mousedownEvent);
	}

	const onKeyDownProcess = props.onKeyDown != null ? props.onKeyDown : (e: KeyboardEvent<HTMLParagraphElement>) => { if(e.key === "Enter") pTagProcess(); }

  return (
	<div className={`flex items-center ${wrapperOption.wrapperStyle}`}>
		<p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} cursor-pointer ${titleless ? 'hidden' : ''}`}
			onClick={() => { if(editable) pTagProcess(); }}
			onKeyDown={onKeyDownProcess}
			tabIndex={editable ? 0 : -1}
		>
		{title}
		 {/* : {initLabelLess ? 'true' : 'false'} */}
		</p>
		<div className={`relative ${wrapperOption.inputStyle}`}>
			<select className={`w-full border-[1px] rounded-[4px] truncate ${editable ? "bg-white" : "bg-gray-disable"}`}
					name={name || ""} value={value}
					onChange={editable ? onChange : undefined}
					onKeyDown={editable ? handleKeyDownSelect : undefined}
					ref={inputRef}
					disabled={!editable}>
				{!initLabelLess && 
					<option value="" selected={value === ''}>{initLabel}</option>
				}

				{
					name === 'compCd'
					? (data as CompanyDto[])?.map((value, index) => <option key={index} value={value.compCd} title={value.compNm}>{value.compNm}</option>)
					: name === 'orgCd' || name === 'eqmOrgcd'
					? (data as OrganizationDto[])?.map((value, index) => <option key={index} value={value.orgCd} title={value.orgNm}>{value.orgNm}</option>)
					: name === 'warehouseCd'
					? (data as WareHouseDto[])?.map((value, index) => <option key={index} value={value.warehouseCd} title={value.warehouseNm}>{value.warehouseNm}</option>)
					: name === 'workplaceCd'
					? (data as WorkPlaceDto[])?.map((value, index) => <option key={index} value={value.workplaceCd} title={value.workplaceNm}>{value.workplaceNm}</option>)
					// (() => { return (data as WareHouseDto[]).map((value, index) => <option key={index} value={value.warehouseCd}>{value.warehouseNm}</option>);
					// })()
					: name === 'equipmentCd'
					? (data as EquipmentDto[])?.map((value, index) => <option key={index} value={value.equipmentCd}>{value.equipmentNm}</option>)
					: name === 'customCd'
					? (data as CustomerResponseDto[])?.map((value, index) => <option key={index} value={value.customCd} title={value.customNm}>{value.customNm}</option>)
					: (data as SysCodeDto[])?.map((value, index) => <option key={index} value={value.minorCd}>{value.codeNm}</option>)
				}
			</select>
		</div>
	</div>
  )
}